import {
  COMPANY_NAME_LENGTH,
  INN_LENGTH,
  OGRN_LENGTH
} from '../../config/constants';
import { IDirectorStep1 } from '../types/Step';

const inctorrectDataText = 'Введенные данные некорректны';

/**
 * Проверка данных первого шага регистрации
 * @param step Данные первого шага
 */
export const checkDirectorStep1 = (step: IDirectorStep1) => {
  const {
    inn,
    ogrn,
    companyName,
    isPersonalDataRulesConfirmed,
    isOfferAgreementConfirmed,
    fileToSign
  } = step;
  let isValid = true;

  const { isCorrect: isInnCorrect, isValid: isInnValid } = inputCheck(
    inn,
    innCheck
  );
  const { isCorrect: isOgrnCorrect, isValid: isOgrnValid } = inputCheck(
    ogrn,
    ogrnCheck
  );
  const { isCorrect: isCompanyNameCorrect, isValid: isCompanyNameValid } =
    inputCheck(companyName, companyNameCheck);

  if (
    !isInnValid ||
    !isOgrnValid ||
    !isCompanyNameValid ||
    !isPersonalDataRulesConfirmed ||
    !isOfferAgreementConfirmed ||
    !fileToSign
  )
    isValid = false;

  return {
    isValid,
    errors: getErrors({ isInnCorrect, isOgrnCorrect, isCompanyNameCorrect })
  };
};

/**
 * Проверка поля инпута
 * @param value Значение
 * @param checker Функция для проверки
 */
const inputCheck = (
  value: string | undefined,
  checker: (value: string) => boolean
) => {
  const isEmpty = value === undefined;

  if (isEmpty) {
    return {
      isCorrect: true,
      isValid: false
    };
  } else {
    const isCorrect = checker(value);

    return {
      isCorrect,
      isValid: isCorrect
    };
  }
};

/**
 * Проверка ИНН
 * @param inn ИНН
 */
const innCheck = (inn: string | undefined) =>
  !!(inn && INN_LENGTH.includes(inn.length));

/**
 * Проверка ОГРН
 * @param ogrn ОГРН
 */
const ogrnCheck = (ogrn: string) =>
  !!(ogrn && OGRN_LENGTH.includes(ogrn.length));

/**
 * Проверка названия компании
 * @param companyName Название компании
 */
const companyNameCheck = (companyName: string) =>
  !!(
    companyName &&
    companyName.length !== 0 &&
    companyName.length <= COMPANY_NAME_LENGTH
  );

/**
 * Получение текста ошибок
 * @param root0 Пропсы
 * @param root0.isInnCorrect Корректный ли ИНН
 * @param root0.isOgrnCorrect Корректный ли ОГРН
 * @param root0.isCompanyNameCorrect Корректно ли название компании
 */
const getErrors = ({
  isInnCorrect,
  isOgrnCorrect,
  isCompanyNameCorrect
}: {
  isInnCorrect: boolean;
  isOgrnCorrect: boolean;
  isCompanyNameCorrect: boolean;
}) => ({
  inn: isInnCorrect ? '' : inctorrectDataText,
  ogrn: isOgrnCorrect ? '' : inctorrectDataText,
  companyName: isCompanyNameCorrect ? '' : inctorrectDataText
});
